import React from 'react'
import ArrowRightIcon from '@isbj-redesign/icons/FaAngleRightLight'

export type Props = {
    direction: 'right' | 'bottom' | 'left' | 'top'
    className?: string
}

export default function ArrowIcon({ direction, className }: Props) {
    const rotate = direction === 'right' ? '' : direction === 'bottom' ? 'fa-rotate-90' : direction === 'left' ? 'fa-rotate-180' : 'fa-rotate-270'
    return (
        <ArrowRightIcon
            className={`${className || ''} ${rotate}`}
            style={{ fontSize: '1.2rem', marginBottom: '-0.2rem', transition: 'transform 0.35s ease' }}
        />
    )
}
